import { columns } from '../consts/consts'

export const getFilter = (searchParams: URLSearchParams) => {
  const appliedFilters: { [key: string]: string } = {}
  columns.forEach((key) => {
    const filterValue = searchParams.get(key)
    if (filterValue !== null) {
      appliedFilters[key] = filterValue
    }
  })
  return  appliedFilters
}
